import { Base } from '@studiometa/js-toolkit';

/**
 * ScrollTop component
 */
export default class ScrollTop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ScrollTop',
    log: true,
    debug: true,
  };

  screenHeight = 0;

  footerHeight = 0;

  /**
   * mounted hook
   */
  mounted() {
    this.screenHeight = window.innerHeight;
    this.footerHeight = document.querySelector('footer').offsetHeight;
  }

  /**
   * resized hook
   */
  resized() {
    this.screenHeight = window.innerHeight;
  }

  /**
   * Detect if we are near the footer
   * @returns {number}
   */
  isNearFooter() {
    const distanceToBottom = document.body.offsetHeight - (window.scrollY + window.innerHeight);
    const threshold = 100;
    return distanceToBottom <= threshold + this.footerHeight;
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {number} y The current vertical scroll position.
   */
  scrolled({ y }) {
    if (this.isNearFooter()) {
      this.$el.classList.add('opacity-0');
      this.$el.classList.add('pointer-events-none');
    } else {
      this.$el.classList.toggle('opacity-0', y < this.screenHeight);
      this.$el.classList.toggle('pointer-events-none', y < this.screenHeight);
    }
  }
}
